/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { IHeader, useLayout } from '../../core'
import { DefaultTitle } from './page-title/DefaultTitle'
import { Topbar } from './Topbar'
import { UserMenu } from '../../../partials/layout/user-menu/UserMenu'

const calculateStickyOffset = (header: IHeader): string => {
  if (header.fixed.desktop && header.fixed.tabletAndMobile) {
    return '{default: "200px", lg: "300px"}'
  }

  if (header.fixed.desktop && !header.fixed.tabletAndMobile) {
    return '{lg: "300px"}'
  }

  if (header.fixed.tabletAndMobile && !header.fixed.desktop) {
    return '{default: "200px", lg: false}'
  }

  return ''
}

const calculateShowSticky = (header: IHeader): boolean => {
  return (
    (header.fixed.desktop && header.fixed.tabletAndMobile) ||
    (header.fixed.desktop && !header.fixed.tabletAndMobile) ||
    (header.fixed.tabletAndMobile && !header.fixed.desktop)
  )
}

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { header } = config
  const [stickyOffset, setStickyOffset] = useState<string>(calculateStickyOffset(header))
  const [showSticky, setShowSticky] = useState<boolean>(calculateShowSticky(header))
  useEffect(() => {
    setStickyOffset(calculateStickyOffset(header))
    setShowSticky(calculateShowSticky(header))
  }, [header])

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '))}
      {...attributes.headerMenu}
      data-kt-sticky={showSticky ? 'true' : 'false'}
      data-kt-sticky-name='header'
      data-kt-sticky-offset={stickyOffset}
    >
      <div
        className={clsx(classes.headerContainer.join(' '), 'd-flex flex-stack flex-wrap gap-2')}
        id='kt_header_container'
      >
        <DefaultTitle />

        {/* begin::Wrapper */}
        <div className='d-flex d-lg-none w-100'>
          {/* begin::Logo */}
          <div className='align-self-center flex-fill'>
            <Link to='/dashboard'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')} className='h-45px theme-light-show' />
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal-dark.svg')} className='h-45px theme-dark-show' />
            </Link>
          </div>
          {/* end::Logo */}
          {/* begin::Aside mobile toggle */}
          <div className='align-self-center'>
            <div className='btn btn-icon btn-outline p-3 m-0 w-100' id='kt_aside_toggle'>
              <KTIcon iconName='abstract-14' className='fs-1 me-2' /> Menü
            </div>
          </div>
          {/* end::Aside mobile toggle */}

          <div className='d-flex flex-stack border d-lg-none ms-2'>
            {/* begin::User menu */}
            <div
              className='btn btn-outline btn-icon p-2 m-0'
              data-kt-menu-trigger='click'
              data-kt-menu-overflow='false'
              data-kt-menu-placement='bottom-end'
            >
              {/* begin::Wrapper */}
              <div className='d-flex'>
                <KTIcon iconName='setting-2' className='fs-1' />
              </div>
            </div>
            <UserMenu />
            {/* end::User menu */}
          </div>
        </div>
        {/* end::Wrapper */}

        <div className='d-none d-lg-flex'>
          <Topbar />
        </div>
      </div>
    </div>
  )
}
